<template>
    <Modal ref="modal" class="create-contact-modal" :close-on-backdrop-click="false" @opened="onModalOpen" @closed="onModalClose">
        <template #button="sp">
            <button type="button" class="btn btn-primary mr-3" @click="sp.showModal()">
                <i class="fad fa-plus"></i> Créer un contact
            </button>
        </template>
        <template #header>
            <div class="h3">
                Création d'un contact
            </div>
        </template>
        <template #body>
            <div class="form-group row">
                <label class="col-4" for="lastname">Nom <small>(requis)</small></label>
                <div class="col-8">
                    <input class="form-control" type="text" name="lastname" id="lastname" v-model="contactLastname">
                </div>
            </div>

            <div class="form-group row">
                <label class="col-4" for="firstname">Prénom <small>(requis)</small></label>
                <div class="col-8">
                    <input class="form-control" type="text" name="firstname" id="firstname" v-model="contactFirstname">
                </div>
            </div>

            <div class="form-group row">
                <label class="col-4" for="email">Email</label>
                <div class="col-8">
                    <input class="form-control" type="email" name="email" id="email" v-model="contactEmail">
                </div>
            </div>

            <div class="form-group row">
                <label class="col-4" for="emails_opt_out">Opposition aux emails Cérès ?</label>
                <div class="col-8">
                    <div class="form-check">
                        <input type="radio" name="emails_opt_out" id="emails_opt_out_yes" :value="1" required="required" class="form-check-input" v-model="contactEmailsOptOut">
                        <label for="emails_opt_out_yes" class="form-check-label">
                            Oui
                        </label>
                    </div>
                    <div class="form-check">
                        <input type="radio" name="emails_opt_out" id="emails_opt_out_no" :value="0" required="required" class="form-check-input" v-model="contactEmailsOptOut">
                        <label for="emails_opt_out_no" class="form-check-label">
                            Non
                        </label>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-4" for="tel">Téléphone</label>
                <div class="col-8">
                    <input class="form-control" type="text" name="tel" id="tel" v-model="contactTel">
                </div>
            </div>

            <div class="form-group row">
                <label class="col-4" for="mobile">Mobile</label>
                <div class="col-8">
                    <input class="form-control" type="text" name="mobile" id="mobile" v-model="contactMobile">
                </div>
            </div>

            <ErrorsZone :errors="errors"></ErrorsZone>
        </template>
        <template #footer>
            <div class="d-flex justify-content-between w-100">
                <button type="button" class="btn btn-secondary" @click="closeModal()">
                    Fermer
                </button>
                <button type="button" class="btn btn-primary" :disabled="loading" @click="createNewContact()">
                    <i class="fad fa-plus"></i> Ajouter
                </button>
            </div>
        </template>
    </Modal>
</template>

<script>
  import ErrorsZone from "../ErrorsZone";
  import Modal from "../Modal";
  import {usePostRequest} from "../compositions/axios/postRequest";

  export default {
      name: "CreateContactModal",

      components: {
          ErrorsZone,
          Modal,
      },

      setup() {
          const {
              loaded,
              loading,
              errors,
              post,
          } = usePostRequest();

          return {
              loaded,
              loading,
              errors,
              post,
          };
      },

      data() {
          return {
              contactLastname: '',
              contactFirstname: '',
              contactEmail: '',
              contactEmailsOptOut: 0,
              contactTel: '',
              contactMobile: '',
          };
      },

      mounted() {
          this.resetFields();
      },

      methods: {
          showModal() {
              this.$refs.modal.showModal()
          },

          onModalOpen() {
              this.$nextTick(() => {
                  const inputs = this.$el.querySelectorAll('input');
                  for (const input of inputs) {
                      input.addEventListener('keydown', (e) => {
                          if (e.key.toUpperCase() === 'ENTER') {
                              e.preventDefault();
                              e.stopPropagation();
                              this.createNewContact();
                          }
                      })
                  }
              })
          },

          closeModal() {
              this.$refs.modal.closeModal();
          },

          onModalClose() {
              this.resetFields();
          },

          resetFields() {
              this.errors = null;

              this.contactLastname = '';
              this.contactFirstname = '';
              this.contactEmail = '';
              this.contactEmailsOptOut = 0;
              this.contactTel = '';
              this.contactMobile = '';
          },

          async createNewContact() {
              const data = await this.post(`/espace-admin/contacts`, {
                  lastname: this.contactLastname,
                  firstname: this.contactFirstname,
                  email: this.contactEmail,
                  emails_opt_out: this.contactEmailsOptOut,
                  tel: this.contactTel,
                  mobile: this.contactMobile,
              });
              if (data && data.contact) {
                  this.$emit('contactCreated', data.contact);
                  this.closeModal();
              }
          },
      },
  }
</script>
